import { gql } from '@apollo/client';

export default gql`
  query UserByEmailQuery($email: String!) {
    user: userByEmail(email: $email) {
      id
    }
  }
`;
